import React, { Component } from 'react';
import { flow } from 'lodash';
import PropTypes from 'prop-types';
import { TweenLite } from 'gsap';
import withSlide from '../Slide';

// element heights in pixels
const animationElementHeight = 390;
const animationImageHeight = 470;

class VerticalPan extends Component {
  extraHeightPercentage =
    ((animationImageHeight - animationElementHeight) * 100) /
    animationImageHeight;

  componentDidMount() {
    const yPercent =
      this.props.panDirection === 'up'
        ? this.extraHeightPercentage
        : this.extraHeightPercentage * -1;

    this.tween = TweenLite.to(this.imgElement, this.props.duration, {
      paused: true,
      yPercent: yPercent
    });

    this.props.setGreensockObjectFunc(this.tween);
  }

  setImgRef = imgElement => {
    this.imgElement = imgElement;
  };

  render() {
    const imageClass =
      'slide__content__animation-type--VerticalPan__img ' +
      'slide__content__animation-type--VerticalPan__img--pan-direction-' +
      this.props.panDirection;

    return (
      <div className={this.props.classNameFunc('VerticalPan')}>
        <img
          alt={this.props.imageAltText}
          className={imageClass}
          ref={this.setImgRef}
          src={this.props.image}
        />
      </div>
    );
  }
}

VerticalPan.defaultProps = {
  panDirection: 'down',
  imageAltText: ''
};

VerticalPan.propTypes = {
  classNameFunc: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  imageAltText: PropTypes.string,
  panDirection: PropTypes.oneOf(['down', 'up']),
  paused: PropTypes.bool.isRequired
};

export default flow(withSlide)(VerticalPan);



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/slideTypes/VerticalPan.js